module.exports = "/images/SuppImg3.jpg";